import { createSelector } from "reselect";
import { denormalizeEntity } from "../utils/jsona";

export const makeGetEntities = () =>
  createSelector(
    entities => entities,
    (_, { id }) => id,
    (_, { type }) => type,
    (entities, id, type) => {
      if (entities && entities[type]) {
        return denormalizeEntity(entities, type, id);
      }
      return void 0;
    }
  );

/**
 * Use this method when fetching a single resource and you want the resource to be an object
 * instead of an array after it is denormalized by jsona
 */
export const makeGetEntity = () =>
  createSelector(
    entities => entities,
    (_, { type }) => type,
    (entities, type) => {
      if (entities && entities[type]) {
        const entityId = Object.keys(entities[type])[0];
        return denormalizeEntity(entities, type, entityId);
      }
      return void 0;
    }
  );
